// TODO IMPROVEMENT: Modify backend response for camelCase

export interface IFund {
  id: number;
  name: string;
}

export class Fund implements IFund {
  constructor(
    public id: number,
    public name: string,
  ) {}
}
